module.exports = __webpack_public_path__ + "static/img/huaweiMatePadPro.812d8200.png";